import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { formatNextImportRome } from "./utils/catalogScheduleDisplay";

const CatalogScheduleNextRun = ({ schedule }) => {
  const [remainingSeconds, setRemainingSeconds] = useState(null);

  useEffect(() => {
    setRemainingSeconds(
      typeof schedule?.seconds_until_next === "number" ? schedule.seconds_until_next : null,
    );
  }, [schedule?.seconds_until_next, schedule?.next_import_at]);

  useEffect(() => {
    if (remainingSeconds == null || remainingSeconds <= 0) {
      return undefined;
    }

    const timer = setInterval(() => {
      setRemainingSeconds((previous) => (previous != null && previous > 0 ? previous - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, [remainingSeconds]);

  if (!schedule) {
    return null;
  }

  if (schedule.scheduled_running) {
    return (
      <div className="cm-schedule-next-run cm-schedule-next-run--status-only" aria-live="polite">
        <Typography className="cm-schedule-next-run-value" component="span">
          Import schedulato in corso
        </Typography>
      </div>
    );
  }

  if (!schedule.enabled || schedule.mode === "off") {
    return (
      <div className="cm-schedule-next-run cm-schedule-next-run--status-only" aria-live="polite">
        <Typography className="cm-schedule-next-run-value" component="span">
          Import schedulati disattivati
        </Typography>
      </div>
    );
  }

  if (schedule.mode === "times") {
    return (
      <div className="cm-schedule-next-run" aria-live="polite">
        <Typography className="cm-schedule-next-run-label" component="span">
          Prossimo import
        </Typography>
        <Typography className="cm-schedule-next-run-value" component="span">
          {formatNextImportRome(schedule.next_import_at)}
        </Typography>
      </div>
    );
  }

  return (
    <div className="cm-schedule-next-run cm-schedule-next-run--status-only" aria-live="polite">
      <Typography className="cm-schedule-next-run-value" component="span">
        Import schedulati disattivati
      </Typography>
    </div>
  );
};

export default CatalogScheduleNextRun;
